<template>
  <div class="navigtorPage">
    <img @click="toAboutUs" class="logo" src="@/assets/PC/navigtor/logo-black.png" alt="">
    <van-popover
      v-model="isExpand"
      placement="bottom-end">
      <template slot="reference">
        <div class="menu" @click="changeExpand">
          <img v-if="isExpand" src="@/assets/mobile/navigtor/expandIcon.png" alt="">
          <img v-else src="@/assets/mobile/navigtor/retractIcon.png" alt="">
        </div>
      </template>
      <template slot="default">
        <div class="routeMenu">
          <div
            class="routeItem"
            v-for="(item,index) in routeList"
            :key="index"
            @click="changeRoute(item.name)">
            {{$t(`nav.${item.name}`)}}
          </div>
        </div>
        <div class="languageMenu">
          <div
            class="languageItem"
            v-for="(item, index) in langList"
            :key="index"
            @click="changeLang(item.value)">
            {{item.label}}
          </div>
        </div>
      </template>
    </van-popover>
  </div>
</template>

<script>
export default {
  name: 'navigtorPage',
  data () {
    return {
      isExpand: false,
      routeList: [
        { name: 'aboutUs' },
        { name: 'fundProduct' },
        { name: 'investorInteraction' },
        { name: 'contactUs' },
        { name: 'news' }
      ],
      langList: [
        {
          label: 'EN',
          value: 'en'
        },
        {
          label: '简体',
          value: 'zh'
        }
      ]
    }
  },
  methods: {
    changeExpand () {
      this.isExpand = !this.isExpand
    },
    changeRoute (name) {
      // 只有点击的不是当前页面才进行跳转，否则默认回到顶部
      if (this.$route.name !== name) {
        this.$router.replace({ name: name })
      }
      window.scrollTo(0, 0)
    },
    changeLang (e) {
      this.langList.forEach(item => {
        if (item.value === e) {
          localStorage.setItem('lang', item.value)
        }
      })
      this.$i18n.locale = e
    },
    toAboutUs () {
      if (this.$route.name === 'aboutUs') {
        window.scrollTo(0, 0)
      } else {
        this.$router.push({
          name: 'aboutUs'
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
.navigtorPage {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 1.6rem;
  padding: 0.43rem;
  width: 100%;
  position: fixed;
  background-color: #fff;
  top: 0;
}
.logo {
  width: 2.8rem;
}
.menu {
  img {
    width: 0.64rem;
    height: 0.64rem;
  }
}
.routeMenu {
  color: #181818;
  background-color: #fff;
  .routeItem {
    font-size: 0.37rem;
    padding: 0.27rem 0.43rem;
    border-bottom: 1px solid #eee;
  }
}
.languageMenu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .languageItem {
    width: 50%;
    height: 1.07rem;
    padding: 0.16rem 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.32rem;
    border-right: 1px solid #eee;
    &:last-child {
      border-right: none;
    }
  }
}
</style>
<style lang="less">
.van-popover--light {
  .van-popover__arrow {
    // color: pink;
  }
}
.van-popover {
  // width: auto !important;
  min-width: 5.6rem !important;
  // left: 4.24rem !important;
  // top: 1.44rem !important;
  .van-popover__arrow {
    right: 0.01rem !important;
    border-width: 0.19rem !important;
  }
}
</style>
